export enum SkillQuestionTypeEnum {
  Text = 'text',
  TestSingle = 'test_single',
  TestMultiple = 'test_multiple',
}

export const SkillQuestionTypeEnumLabels: Record<SkillQuestionTypeEnum, string> = {
  [SkillQuestionTypeEnum.Text]: 'Texto',
  [SkillQuestionTypeEnum.TestSingle]: 'Test opción única',
  [SkillQuestionTypeEnum.TestMultiple]: 'Test opción múltiple',
};

export const SkillQuestionTypeEnumOptions: { value: SkillQuestionTypeEnum; label: string }[] = [
  { value: SkillQuestionTypeEnum.Text, label: SkillQuestionTypeEnumLabels[SkillQuestionTypeEnum.Text] },
  { value: SkillQuestionTypeEnum.TestSingle, label: SkillQuestionTypeEnumLabels[SkillQuestionTypeEnum.TestSingle] },
  { value: SkillQuestionTypeEnum.TestMultiple, label: SkillQuestionTypeEnumLabels[SkillQuestionTypeEnum.TestMultiple] },
];
